import { lazy } from 'react';

export const PlayerRemoveWagerLimitForm = lazy(
  () => import('./PlayerRemoveWagerLimitForm'),
);
